<template>
  <div>
    <div class="row mt-1 ml-2">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-history text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial de Contrato
        </span>
      </div>
    </div>
    <custom-result-not-found
      v-if="items.length === 0"
      text="No cuenta con contrato(s) en sistema."
    />
    <div v-for="(data, index) in items" :key="index">
      <custom-callout
        class-main="mt-3 ml-4"
        :has-border="false"
        :has-gradient="false"
        :has-toggle="false"
      >
        <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
          <div class="col-12 col-md-1 my-2">
            <div class="color-gray-6 font-14">Año Fiscal:</div>
            <div class="color-black font-16">
              {{ data.fiscalYear | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Proveedores:</div>
            <div class="color-black font-16">
              {{ data.providerName | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Especialista:</div>
            <div class="color-black font-16">
              {{ data.specialistName | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Número de Contrato:</div>
            <div class="color-black font-16">
              {{ data.contractNumber | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Estatus:</div>
            <div class="color-black font-16">
              {{ data.statusDescription | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Inicio de Contrato:</div>
            <div class="color-black font-16">
              {{ data.contractStartDate | date('DD/MM/YYYY') }}
            </div>
          </div>
          <div class="col-12 col-md text-sm-right mt-3 mt-sm-1">
            <action-button
              i="fas fa-print pl-2"
              variant="success"
              @click="$emit('download-item', data)"
            />
          </div>
        </div>
      </custom-callout>
    </div>
    <slot name="pagination" />
  </div>
</template>
<script>
import CustomCallout from 'custom-callout';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';

export default {
  name: 'RequestServiceContractHistory',
  components: {
    CustomCallout,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
